import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

/**
 * StickyServiceCta — appears at the bottom-right after the user scrolls past the
 * service-page hero. Provides one-click access to discovery booking with
 * service-context in the eyebrow text. Auto-hides once dismissed.
 */
const StickyServiceCta = ({ serviceName, ctaPath = "/contact" }) => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const onScroll = () => {
      setVisible(window.scrollY > 720);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [dismissed]);

  if (!visible || dismissed) return null;

  return (
    <div
      style={{ bottom: "calc(1.25rem + var(--ek-cookie-bar-h, 0px))" }}
      className="fixed right-5 z-[60] max-w-[calc(100vw-2.5rem)] sm:max-w-sm shadow-2xl border border-white/15 bg-black text-white"
      role="complementary"
      aria-label={`Discovery call for ${serviceName}`}
      data-testid="sticky-service-cta"
    >
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="absolute top-2 right-2 w-7 h-7 grid place-items-center text-zinc-500 hover:text-white"
        data-testid="sticky-cta-dismiss"
      >
        <X size={14} />
      </button>
      <div className="p-5 pr-10">
        <div className="ek-eyebrow text-[#A179FA] text-[10px]">
          {serviceName ? serviceName : "Discovery"}
        </div>
        <p className="ek-heading text-[15px] mt-2 leading-snug">
          Talk this through with us — 30 minutes, free.
        </p>
        <p className="text-zinc-400 text-[12.5px] mt-1">
          Leave with three prioritised next steps.
        </p>
        <Link
          to={ctaPath}
          className="ek-btn ek-btn-primary mt-4 text-[13px] px-4 py-2.5"
          data-testid="sticky-cta-book"
        >
          Book a discovery <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
};

export default StickyServiceCta;
